import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Checkbox, Tooltip } from "@mui/material";
import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";
import { useForm } from "react-hook-form";
import {
  getDoctorList,
  searchService,
} from "../../services/charges/IPDCharges";
import InputField from "../../../common/components/FormFields/InputField";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import DropdownField from "../../../common/components/FormFields/DropdownField";

export default function AlterIPDChargesTable(props) {
  const {
    selected,
    setSelected,
    setCheckIsPackage,
    tariffId,
    selectedPatient,
  } = props;

  const { control, setValue, register } = useForm();
  // const [confirmAction, setconfirmAction] = React.useState(false);
  // const [rescheduleAction, setrescheduleAction] = React.useState(false);
  // const [cancelAction, setcancelAction] = React.useState(false);
  //state varibale for the table
  const [serviceList, setServiceList] = React.useState([]);
  const [doctorOptions, setDoctorOptions] = React.useState([]);

  const removeHeaders = (headers, fieldToRemove) => {
    return headers.filter((v) => {
      return !fieldToRemove.includes(v);
    });
  };

  //set rows object to table
  const allHeaders = Object.keys(props.data[0]);

  const headers = removeHeaders(allHeaders, [
    "Id",
    "doctorId",
    "serviceId",
    "rateEditAllowed",
    "discountApplicable",
    "doctorShareApplicable",
    "billInfoId",
    "DiscountPerc",
    "DiscountAmt",
    "ChargeId",
    "ServiceCode",
    "Opd_Ipd_External_Id",
    "LoginName",
    "OTSheetNo",
    "RateEditable",
    "DoctorId",
    "StaffFree",
    "IsPackage",
    "SponsorType",
    "ServiceId",
    "DiscountPerc",
    "AdminCharges",
    "IsServiceTaxApp",
    "IsGSTApplicable",
    "deductible",
    "NetAmt",
    "IsCancelled",
  ]);

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    let obj = newSelected.find((o) => o.IsPackage === true);
    if (typeof obj !== "undefined") {
      setCheckIsPackage(true);
    } else {
      setCheckIsPackage(false);
    }
    setSelected(newSelected);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;

  const handleChange = (e) => {
    let unitkey = JSON.parse(localStorage.getItem("userInfo"));
    if (e.length > 0 && selectedPatient) {
      let finalSearchObj = {
        description: e,
        tariffId: tariffId,
        unitId: unitkey.unitId,
        groupId: 0,
        classId: selectedPatient.classId,
        companyId: selectedPatient.CompanyId,
        applicableTo: 1,
        isEmergency: false,
      };
      searchService(finalSearchObj)
        .then((response) => {
          //
          setServiceList(response.data.result);
          // setActions(response.data.actions);
        })
        .catch((response) => {});
    }
  };

  const handleDoctorSearch = (searchString) => {
    if (searchString.length > 0) {
      getDoctorList(searchString).then((response) => {
        setDoctorOptions(response.data.result);
      });
    }
  };

  return (
    <>
      <div className="grid w-auto">
        <Box sx={{ width: "100%", overflow: "hidden" }}>
          <Paper sx={{ width: "100%", my: 1 }}>
            <TableContainer
              sx={{
                "&::-webkit-scrollbar": {
                  width: 7,
                  height: 10,
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "lightBlue",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#1e3a8a",
                  borderRadius: 4,
                },
              }}
              className="max-h-96"
            >
              <Table
                size="small"
                stickyHeader
                aria-label="sticky table"
                sx={{
                  border: 1,
                  borderColor: "#e0e0e0",
                  paddingY: "scroll",
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        paddingY: 0.5,
                        backgroundColor: "#F1F1F1",
                      },
                    }}
                  >
                    <TableCell
                      className="whitespace-nowrap"
                      style={{ background: "#F1F1F1" }}
                    >
                      <span className="text-gray-600 font-bold">Actions</span>
                    </TableCell>

                    {headers.map((header, index) => (
                      <TableCell
                        className="whitespace-nowrap"
                        key={index}
                        style={{ background: "#F1F1F1" }}
                      >
                        <span className="text-gray-600 font-bold">
                          {header}
                        </span>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.data?.map((row, index) => {
                    const isItemSelected = isSelected(row);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    setValue(`description${index}`, {
                      value: row?.Description,
                      label: row?.Description,
                    });
                    setValue(`rate${index}`, row?.Rate);
                    setValue(`quantity${index}`, row?.Quantity);
                    setValue(
                      `doctor${index}`,
                      row?.Doctor !== null
                        ? {
                            id: row?.DoctorId,
                            value: row?.DoctorId,
                            label: row?.Doctor,
                          }
                        : null
                    );
                    return (
                      <TableRow
                        key={index}
                        hover
                        // onClick={(event) => handleClick(event, row)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        selected={isItemSelected}
                      >
                        <TableCell className="px-4 py-1 flex whitespace-nowrap ">
                          <Tooltip title="Delete">
                            <button
                              className="text-red-500 mr-3"
                              onClick={() => {
                                let tempData = [...props?.data];
                                tempData?.splice(index, 1);
                                props?.setData(tempData);
                              }}
                            >
                              {<DeleteOutlineOutlinedIcon />}
                            </button>
                          </Tooltip>
                        </TableCell>
                        {headers &&
                          headers.map((header, i) => {
                            console.log("headerValue", row[header]);

                            return (
                              <>
                                {header === "Description" ? (
                                  <TableCell
                                    className="whitespace-nowrap"
                                    key={i}
                                  >
                                    <div className="w-60">
                                      <CreateableSelect
                                        control={control}
                                        name={`description${index}`}
                                        placeholder="Description"
                                        onInputChange={handleChange}
                                        dataArray={serviceList}
                                        inputRef={{
                                          ...register(`description${index}`, {
                                            onChange: (e) => {
                                              let tempData = [...props?.data];
                                              if (e.target?.value !== null) {
                                                tempData[index].Description =
                                                  e?.target?.value?.label;
                                              } else {
                                                tempData[index].Description =
                                                  "";
                                              }
                                              props?.setData(tempData);
                                            },
                                          }),
                                        }}
                                      />
                                    </div>
                                  </TableCell>
                                ) : header === "Rate" ? (
                                  <TableCell
                                    className="whitespace-nowrap"
                                    key={i}
                                  >
                                    <div className="w-20">
                                      <InputField
                                        control={control}
                                        name={`rate${index}`}
                                        label="Rate"
                                        type="number"
                                        inputRef={{
                                          ...register(`rate${index}`, {
                                            onChange: (e) => {
                                              let tempData = [...props?.data];
                                              if (e.target?.value !== "") {
                                                tempData[index].Rate = Number(
                                                  e?.target?.value
                                                );
                                                tempData[index].TotalAmount =
                                                  Number(e?.target?.value) *
                                                  row?.Quantity;
                                                tempData[index].NetAmount =
                                                  Number(
                                                    Number(e?.target?.value) *
                                                      row?.Quantity
                                                  ) - row?.Discount;
                                              } else {
                                                tempData[index].Rate = "";
                                                tempData[index].TotalAmount =
                                                  "";
                                                tempData[index].NetAmount = "";
                                              }
                                              props?.setData(tempData);
                                            },
                                          }),
                                        }}
                                      />
                                    </div>
                                  </TableCell>
                                ) : header === "Quantity" ? (
                                  <TableCell
                                    className="whitespace-nowrap"
                                    key={i}
                                  >
                                    <div className="w-20">
                                      <InputField
                                        control={control}
                                        name={`quantity${index}`}
                                        label="Quantity"
                                        type="number"
                                        inputRef={{
                                          ...register(`quantity${index}`, {
                                            onChange: (e) => {
                                              console.log(
                                                "quantityValue",
                                                e?.target?.value
                                              );

                                              let tempData = [...props?.data];
                                              if (e.target?.value !== "") {
                                                tempData[index].Quantity =
                                                  Number(e?.target?.value);
                                                tempData[index].TotalAmount =
                                                  row?.Rate *
                                                  Number(e?.target?.value);
                                                tempData[index].NetAmount =
                                                  Number(
                                                    row?.Rate *
                                                      Number(e?.target?.value)
                                                  ) - row?.Discount;
                                              } else {
                                                tempData[index].Quantity = "";
                                                tempData[index].TotalAmount =
                                                  "";
                                                tempData[index].NetAmount = "";
                                              }
                                              props?.setData(tempData);
                                            },
                                          }),
                                        }}
                                      />
                                    </div>
                                  </TableCell>
                                ) : header === "Doctor" ? (
                                  <TableCell
                                    className="whitespace-nowrap"
                                    key={i}
                                  >
                                    <div className="w-60">
                                      <DropdownField
                                        name={`doctor${index}`}
                                        control={control}
                                        placeholder="Doctor"
                                        dataArray={doctorOptions}
                                        onInputChange={handleDoctorSearch}
                                        isSearchable={true}
                                        isClearable={true}
                                        inputRef={{
                                          ...register(`doctor${index}`, {
                                            onChange: (e) => {
                                              let tempData = [...props?.data];
                                              if (e.target?.value !== null) {
                                                tempData[index].Doctor =
                                                  e?.target?.value?.label;
                                                tempData[index].DoctorId =
                                                  e?.target?.value?.id;
                                              } else {
                                                tempData[index].Doctor = null;
                                                tempData[index].DoctorId = 0;
                                              }
                                              props?.setData(tempData);
                                            },
                                          }),
                                        }}
                                      />
                                    </div>
                                  </TableCell>
                                ) : row[header] !== null ? (
                                  <TableCell
                                    key={i}
                                    className="whitespace-nowrap"
                                  >
                                    {row[header]}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    className="whitespace-nowrap"
                                    key={i}
                                  >
                                    -
                                  </TableCell>
                                )}
                              </>
                            );
                          })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </div>
    </>
  );
}
